import { render, staticRenderFns } from "./ForeignIDList.vue?vue&type=template&id=4e27e0ee&scoped=true&"
import script from "./ForeignIDList.vue?vue&type=script&lang=ts&"
export * from "./ForeignIDList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e27e0ee",
  null
  
)

export default component.exports